import { useEffect, useRef, useState } from "react";
import ChartRace from "../../ChartRace";

const colorsArr = ["#FF0000", "#FF00FF", "#FFD700", "#FF5E5B", "#FFBF00"];

function generateRandomColor() {
  let color;
  do {
    color =
      "#" +
      Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, "0");
  } while (color.toUpperCase() === "#FFFFFF");
  return color;
}

// const stringToColor = (str) => {
//   let hash = 0;
//   for (let i = 0; i < str.length; i++) {
//     hash = str.charCodeAt(i) + ((hash << 5) - hash);
//   }
//   const h = Math.abs(hash) % 360;
//   return `hsl(${h}, 60%, 70%)`;
// };

export function useParentSize() {
  const ref = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      window.requestAnimationFrame(() => {
        setSize({ width, height });
      });
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return [ref, size];
}

export default function PostRace({ race }) {
  const [containerRef, { width }] = useParentSize();
  const [raceData, setRaceData] = useState([]);
  const [frameIndex, setFrameIndex] = useState(0);
  const [uniqueDates, setUniqueDates] = useState([]);

  useEffect(() => {
    if (race) {
      setUniqueDates([...new Set(race.data.map((e) => e.date))].sort());
    }
  }, [race]);

  useEffect(() => {
    if (!race) return;

    if (uniqueDates.length === 0) return;

    const interval = setInterval(() => {
      if (frameIndex >= uniqueDates.length) {
        // clearInterval(interval);
        setFrameIndex(0);
        return;
      }

      const currentDate = uniqueDates[frameIndex];
      const frameEntries = race.data
        .filter((e) => e.date === currentDate)
        .map((e, i) => ({
          id: e._id,
          title: e.name,
          value: e.value || 0,
          date: e.date,
          // color: colorsArr[i % colorsArr.length],
          color: generateRandomColor(),
        }));

      setRaceData(frameEntries);
      setFrameIndex((prev) => prev + 1);
    }, 2000);

    return () => clearInterval(interval);
  }, [frameIndex, race, uniqueDates]);

  return (
    <div
      ref={containerRef}
      style={{
        maxWidth: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {width > 0 && (
        <ChartRace
          data={raceData}
          width={width}
          height={400}
          itemHeight={20}
          gap={4}
          titleStyle={{
            font: "18px sans-serif",
            position: "absolute",
            left: "10px",
            color: "white",
          }}
          valueStyle={{ font: "16px sans-serif" }}
        />
      )}
      <span
        style={{
          position: "absolute",
          bottom: "10px",
          right: "12px",
          color: "#000000",
          fontSize: "0.9em",
          fontWeight: "700",
          transform: "translateY(-50%)", // pull up by half own height
          writingMode: "vertical-rl", // make text flow vertically
          // textOrientation: 'upright',    // keep characters upright
        }}
      >
        {raceData[0]?.date}
      </span>
    </div>
  );
}

